"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.headerCellFactory = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _sortIdle = require("../../../../assets/icons/sort-idle.svg");
var _sortDesc = require("../../../../assets/icons/sort-desc.svg");
var _sortAsc = require("../../../../assets/icons/sort-asc.svg");
var _noop = require("../../../../utils/noop");
var _headerCellModule = _interopRequireDefault(require("./header-cell.module.scss"));
var headerCellFactory = function headerCellFactory(baseClassName) {
  var HeaderCell = /*#__PURE__*/_react.default.memo(function (_ref) {
    var children = _ref.children,
      _ref$onColumnSort = _ref.onColumnSort,
      onColumnSort = _ref$onColumnSort === void 0 ? _noop.noop : _ref$onColumnSort,
      direction = _ref.direction,
      _ref$hasThreeStateSor = _ref.hasThreeStateSorting,
      hasThreeStateSorting = _ref$hasThreeStateSor === void 0 ? false : _ref$hasThreeStateSor,
      className = _ref.className;
    var icon = (0, _react.useMemo)(function () {
      switch (direction) {
        case 'ASCENDING':
          return /*#__PURE__*/_react.default.createElement(_sortAsc.ReactComponent, {
            "data-testid": "sort-ascending-icon",
            className: _headerCellModule.default['header-cell__icon'],
            onClick: function onClick() {
              return onColumnSort(hasThreeStateSorting ? 'IDLE' : 'DESCENDING');
            }
          });
        case 'DESCENDING':
          return /*#__PURE__*/_react.default.createElement(_sortDesc.ReactComponent, {
            "data-testid": "sort-descending-icon",
            className: _headerCellModule.default['header-cell__icon'],
            onClick: function onClick() {
              return onColumnSort('ASCENDING');
            }
          });
        case 'IDLE':
          return /*#__PURE__*/_react.default.createElement(_sortIdle.ReactComponent, {
            "data-testid": "sort-idle-icon",
            className: _headerCellModule.default['header-cell__icon'],
            onClick: function onClick() {
              return onColumnSort('DESCENDING');
            }
          });
        default:
          return null;
      }
    }, [direction, onColumnSort, hasThreeStateSorting]);
    return /*#__PURE__*/_react.default.createElement("th", {
      className: (0, _classnames.default)(_headerCellModule.default['header-cell'], baseClassName, className)
    }, children, icon);
  });
  HeaderCell.displayName = 'HeaderCell';
  return HeaderCell;
};
exports.headerCellFactory = headerCellFactory;